<template>
  <w-sliding-popup ref="slidingPopup" title="장애티켓 처리 현황" width="950px" @close="initTicketStatusPopup">
    <div slot="content">
      <w-event-ticket-status class="ticket-status-popup" ref="statusRef" :isReadOnlyTicket="isReadOnlyTicket" :is-popup-view="isPopupView" :params= "troubleTicketParams" ></w-event-ticket-status>
    </div>
  </w-sliding-popup>
</template>

<script>
import WEventTicketStatus from '@/views/event/components/EventTicketStatus';

export default {
  name: 'WEventTicketStatusPopup',
  components: { WEventTicketStatus },
  props: {
    troubleTicketInfo: {
      type: Object,
    },
    isReadOnlyTicket: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPopupView: true,
      troubleTicketParams: null,
      inputReportFlag: true,
    };
  },
  watch: {
    troubleTicketInfo: {
      immediate: true,
      handler(value) {
        this.troubleTicketParams = value;
      },
    },
  },
  methods: {
    initTicketStatusPopup() {
      this.troubleTicketParams = null;
    },
    open() {
      this.$refs.slidingPopup.open();
    },
  },
};
</script>

<style>
.ticket-status-popup .list-dot-tit {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/event/components/popup/EventTicketStatusPopup.vue